import PropTypes from 'prop-types';
import './RemoteCollectionTransaction.scss';
import { useTranslation } from 'react-i18next';
import Entity from '../entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import useDeviceSizeStore from '@/app/store/deviceSize';

/**
 *
 * @param root0
 * @param root0.amount
 * @param root0.currency
 * @param root0.isTransactionInError
 * @param root0.isRemoteCollectionEmpty
 * @param root0.spanClassName
 * @param root0.additionalText
 * @param root0.namespace
 * @param root0.row
 * @param root0.className
 * @returns {JSX.Element} RenderInternationalizedAmount
 */
function RenderInternationalizedAmount({
    amount,
    currency,
    isTransactionInError,
    isRemoteCollectionEmpty,
    spanClassName,
    additionalText = undefined,
    namespace = undefined,
    row,
    className = ''
}) {

    // Language
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage;

    // Store
    const isSmallDevice = useDeviceSizeStore(state => state.isSmallDevice);

    // Constants
    const isNegative = amount && amount < 0;

    // Functions
    const convertAmount = () => {
        const currencyCode = currency || 'EUR';
        return amount.toLocaleString(lang, { style: 'currency', currency: currencyCode });
    };
    const getClassNames = () => {
        if (isNegative) {
            return 'is-negative-amount';
        }
        if (isTransactionInError || isRemoteCollectionEmpty) {
            return 'error-transaction-empty-collection';
        }
        return 'is-important is-positive-amount';
    };

    // Updates row background color if amount is negative or remote collection is empty - nothing happens if no row is provided
    if (row) {
        if (isRemoteCollectionEmpty) {
            row.class = 'error-row-light';
        }
        if (isNegative) {
            row.class = 'error-row';
        }
    }
    return (
        <>
            {additionalText && !isSmallDevice ?
                <Entity
                    className={cn(
                        spanClassName || '',
                        getClassNames(),
                        className
                    )}
                    entity={additionalText}
                    data={{ amount: convertAmount() }}
                    namespace={namespace}
                    nowrap
                />
                :
                <span
                    className={cn(
                        spanClassName || '',
                        getClassNames(),
                        className
                    )}>
                    {convertAmount()}
                </span>
            }
        </>
    );
}
RenderInternationalizedAmount.propTypes = {
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string,
    isTransactionInError: PropTypes.bool,
    isRemoteCollectionEmpty: PropTypes.bool,
    spanClassName: PropTypes.string,
    additionalText: PropTypes.string,
    namespace: PropTypes.string,
    row: PropTypes.object,
    className: PropTypes.string
};
export default RenderInternationalizedAmount;